module.exports = __webpack_public_path__ + "img/shipo-icon-edit-upload-primary.97d0a0b2.svg";